import { AttributeParser } from "@/utils/attribute-parser/attribute-parser";

export class ManualScroll extends HTMLElement {
  private clientX = 0;
  private clientY = 0;
  private thresholdX;
  private thresholdY;
  private cumulativeThresholdX = 0;
  private cumulativeThresholdY = 0;
  private isActive = false;
  private attr: AttributeParser;
  private controller?: AbortController;
  private moveController?: AbortController;

  constructor() {
    super();

    this.attr = new AttributeParser(this);

    this.thresholdX = this.attr.number("threshold-x", 30);
    this.thresholdY = this.attr.number("threshold-y", 30);
  }

  connectedCallback() {
    this.create();
  }

  disconnectedCallback() {
    this.destroy();
  }

  public create() {
    this.controller = new AbortController();
    this.setAttribute("draggable", "false");
    this.addEventListener("mousedown", this.onMouseScrollStart, {
      signal: this.controller.signal,
    });
    this.addEventListener("dragstart", this.onPreventDefault, {
      signal: this.controller.signal,
    });
  }

  public destroy() {
    this.controller?.abort();
    this.moveController?.abort();
    this.removeAttribute("draggable");
    this.style.removeProperty("pointer-events");
  }

  private onPreventDefault = (event: Event) => {
    event.preventDefault();
  };

  private onMouseScrollStart = (event: MouseEvent) => {
    event.preventDefault();
    this.isActive = true;
    this.clientX = event.clientX;
    this.clientY = event.clientY;
    this.cumulativeThresholdX = 0;
    this.cumulativeThresholdY = 0;
    this.moveController = new AbortController();
    document.addEventListener("mousemove", this.onMouseScroll, {
      signal: this.moveController.signal,
    });
    document.addEventListener("mouseup", this.onMouseScrollStop, {
      signal: this.moveController.signal,
    });
  };

  private onMouseScrollStop = () => {
    this.isActive = false;
    this.clientX = 0;
    this.clientY = 0;
    this.cumulativeThresholdX = 0;
    this.cumulativeThresholdY = 0;
    this.style.removeProperty("pointer-events");
    this.moveController?.abort();
  };

  private isScrollXAvailable = () => {
    return this.clientWidth < this.scrollWidth;
  };

  private isScrollYAvailable = () => {
    return this.clientHeight < this.scrollHeight;
  };

  private onMouseScroll = (event: MouseEvent) => {
    if (this.isActive) {
      const deltaX = this.clientX - event.clientX;
      const deltaY = this.clientY - event.clientY;

      if (this.isScrollXAvailable()) {
        this.cumulativeThresholdX += Math.abs(deltaX);

        if (this.cumulativeThresholdX > this.thresholdX) {
          this.style.setProperty("pointer-events", "none");
          this.scrollLeft += deltaX;
          this.clientX = event.clientX;
        }
      }

      if (this.isScrollYAvailable()) {
        this.cumulativeThresholdY += Math.abs(deltaY);

        if (this.cumulativeThresholdY > this.thresholdY) {
          this.style.setProperty("pointer-events", "none");
          this.scrollTop += deltaY;
          this.clientY = event.clientY;
        }
      }
    }
  };
}
